var map = {
	"./facebook.svg": "aaa3",
	"./google.svg": "0895",
	"./loading-spinner.svg": "616b",
	"./microsoft.svg": "0544",
	"./no_avatar.png": "95ac",
	"./others.svg": "b47c",
	"./stage-logo.png": "558b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";